// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"flex_wrapper__ENJ_X","title":"flex_title__p6gJB","grid":"flex_grid__VTGaN","item":"flex_item__XNPom","image":"flex_image__ubZdi","content":"flex_content__TwmXN"};